<template>
  <div class="container marketing">
    <div class=" col-lg-5 col-xs-5"
         v-for="item in imgList"
         :key="item.appName"
         style="margin: 18px 3%;padding: 10px;background:#FFFFFF;border-radius: 6px">
      <template>
        <a-card hoverable>
          <template>
            <img slot="cover"
                 alt="example"
                 :src="item.img"/>
          </template>
          <a-card-meta class="ant-card-body">
            <template slot="description">
              <router-link :to="item.routePath" @click.native="checkUser"
                           style="padding: 0 0 15px 10px;font-weight: 700;font-size: 60%">
                {{ item.appName }}
              </router-link>
            </template>
          </a-card-meta>
        </a-card>
      </template>
    </div>
  </div>
</template>
<script>
import {getShopslist, createCourseOrder, addAgent, getShopsCategory} from "@/api/shops";

export default {
  watch: {
    // "$store.state.user.token": {
    //   handler: function () {
    //     this.getShop()
    //   }
    // },
  },
  created() {
  },
  computed: {},
  data() {
    return {
      imgList: [
        {
          img: require("../assets/images/databind.png"),
          appName: "数据关联",
          routePath: "/data_bind",
        },
        {
          img: require("../assets/images/query_data_bind.png"),
          appName: "查询关联",
          routePath: "/query_data_bind",
        },
        {
          img: require("../assets/images/ruku.png"),
          appName: "入库扫码",
          routePath: "/in_repository",
        },
        {
          img: require("../assets/images/chuku.png"),
          appName: "出库扫码",
          routePath: "/out_repository",
        },
        {
          img: require("../assets/images/back.png"),
          appName: "退货入库",
          routePath: "/back_repository",
        },
        {
          img: require("../assets/images/lingshou.png"),
          appName: "零售出库",
          routePath: "/ratail_repository",
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
    checkUser() {
      if (!this.$store.state.user.token) {
        this.$message.error("请完成登录")
      }
    }
  }
  ,
}
;
</script>
<style scoped>
.marketing {
  margin-top: 100px;
  margin-left: 5%;
}

.marketing .col-lg-2 {
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
}

.col-lg-3:nth-child(4n+1) {
  clear: left;
}

.col2:nth-child(2n+1) {
  clear: left;
}

.table-dark {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.pagein-right {
  float: right;
}

.noaction {
  color: #929292;
  font-size: 18px
}

.action {
  color: rgb(29, 142, 242);
  font-size: 18px;
}

.ant-card-bordered {
  border: #1890ff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-card-bordered {
  font-size: 20px;

}

.ant-card-cover > * {
  width: 40px;
  height: 40px;
  margin: auto;
  /*padding-bottom: 20px;*/
}

/deep/ .ant-card-bordered .ant-card-body {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
}

.el-textarea {
  padding: 20px 40px;
}

.el-select {
  margin: 20px 0;
}

.nav-time {
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  /* justify-content: center; */
}

.p-box {
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
  padding-left: 10px;
}

.title1 {
  font-size: 30px;
  color: var(--text-color-darker);
  text-align: center;
  font-weight: 300;
}

.title1::after {
  content: "";
  display: block;
  width: 6%;
  height: 4px;
  background-color: var(--primary-color);
  margin: 14px auto 30px;
  transform: translateX(10%);
}

.iconfont {
  width: 12px;
  height: 12px;
}

.line-30 {
  line-height: 30px;
}

.items {
  /*border: 1px solid #929292;*/
  padding: 10px;
  margin-bottom: 15px;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 5px 5px 2px #888888;
}

/deep/ .ant-tabs-tab {
  margin: 0 2px !important;
  padding: 0 3px !important;
  background: #ffffff !important;
  font-size: 12px;
  font-weight: 600;
}

/deep/ .ant-modal-body {
  padding: 5px 20px;
}

/deep/ .ant-tabs-tab-prev {
  color: #3967FF !important;
}

/deep/ .ant-tabs-tab-next {
  color: #3967FF !important;
}

/deep/ .ant-form-item-label, .ant-form-item {
  padding-bottom: 0 !important;
  margin-bottom: 10px;
}
</style>

